// Navigation.js
import React, { useState } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import { NavigationData } from "./NavigationData";
import "./Navigation.css";
import { IconContext } from "react-icons";

function Navigation() {
  const [sidebar, setSidebar] = useState(false);
  
  const showSidebar = () => setSidebar(!sidebar);

  return (
    <> 
      <IconContext.Provider value={{ color: "undefined" }}>
        <div className="navigation">
          <Link to="#" className="menu-bars">
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
        </div>
        <nav className={sidebar ? "navigation-menu active" : "navigation-menu"}>
          <ul className="navigation-menu-items" onClick={showSidebar}>
            <li className="navigation-toggle">
              <Link to="#" className="menu-bars">
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {NavigationData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
      <br></br>
    </>
  );
};

export default Navigation;